export const ItemTypes = {
  OUTLINE: 'outline',
  PORTFOLIO: 'portfolio',
};

export const DropLocation = {
  ON_TARGET_HORIZONTAL_MIDPOINT: 'onTargetHorizontalMidPoint',
  ABOVE_TARGET: 'aboveTarget',
  BELOW_TARGET: 'belowTarget',
  INITIAL: 'initial',
};

export const BUFFER_ROOM = 8;